module.exports = __webpack_public_path__ + "img/pro2.c0da5b0a.svg";